import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description DollarSign icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { DollarSign } from '@sravni/design-system-icons'
 *
 * <DollarSign />
 * ```
 */
var DollarSign = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "DollarSign", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10 5v1.25M15.303 4.697A7.5 7.5 0 1 1 4.697 15.303 7.5 7.5 0 0 1 15.303 4.697ZM10 15v-1.25", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M7.5 11.88c0 1.035.84 1.874 1.875 1.874h1.37a1.756 1.756 0 0 0 .427-3.458l-2.344-.588a1.755 1.755 0 0 1 .428-3.458h1.369c1.036 0 1.875.84 1.875 1.875", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { DollarSign };
//# sourceMappingURL=DollarSign.js.map
